<template>
  <el-upload
    drag
    action="#"
    :file-list="fileList"
    :multiple="multiple"
    :on-success="uploadSuccess"
    :http-request="httpUpload"
  >
    <el-icon class="el-icon--upload">
      <upload-filled />
    </el-icon>
    <div class="el-upload__text">
      将文件拖到此处，或<em>点击上传</em>
    </div>
    <template #tip>
      <div class="el-upload__tip">
        文件后缀名必须为xls或xlsx(即Excel格式)文件大小不得大于10M
      </div>
    </template>
  </el-upload>
</template>

<script>
import { getOssParams } from '@/api/oss'
import common from '@/util/upload'

export default {
  name: 'DyFileUpload',
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    acceptOptions: [
      ['jpg', 'png', 'jpeg', 'gif', 'svg'],
      ['xls', 'xlsx'],
      ['doc', 'docx'],
      ['pdf'],
      ['amr']
    ],
    size: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      fileList: [],
      ossParams: {
        enable: true,
        endpoint: 'https://oss-cn-beijing.aliyuncs.com',
        customDomain: null,
        pathStyleAccess: true,
        region: null,
        accessKey: 'LTAI4GF1BhyA6RGHswf5safg',
        secretKey: 'TiiLzmc9ip309NKChJmxtvc5rwSId6',
        bucketName: 'eco-platform-test'
      }
    }
  },
  computed: {
    accept() {
      return this.fileTypesSuffix.map((item) => '.' + item).join(',')
    },
    fileTypesSuffix() {
      if (!this.fileType) return this.acceptOptions[0]
      if (Array.isArray(this.fileType)) {
        let arr = []
        this.acceptOptions.filter((item, index) => {
          if (this.fileType.includes(index)) {
            arr = arr.concat(item)
          }
        })
        return arr
      } else {
        return this.acceptOptions[this.fileType]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getOssParams().then(ossRes => {
        this.ossParams = ossRes.data.data
      })
    },
    beforeUpload(file) {
      const validType = this.fileTypesSuffix.filter((type) =>
        file.type.includes(type)
      )
      const splitArr = file.name.split('.')
      const suffix = splitArr[splitArr.length - 1]
      const validSuffix = this.fileTypesSuffix.filter((type) => type === suffix)
      const validSize = file.size / 1024 / 1024 > this.size
      if (validType.length === 0 && validSuffix.length === 0) {
        this.$message.error('上传文件格式错误!')
        return false
      }
      if (validSize) {
        this.$message.error('上传文件过大')
        return false
      }
      return true
    },
    async httpUpload(file) {
      const uploadFileRes = await common.attachUpload(this.ossParams, file)
      return Promise.resolve(uploadFileRes)
    },
    uploadSuccess(res, file) {
      file.response = res
      file.percentage = 100
      if (this.fileList) {
        this.fileList.length >= this.limit && this.fileList.splice(0, 1)
        this.fileList.push(file)
        this.$emit('uploadSuccess', this.fileList)
      } else {
        this.$emit('uploadSuccess', [file])
      }
    }
  }
}
</script>

<style scoped>

</style>
